import { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const useDownloadTanNumberTemplate = () => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadTanNumberTemplate = () => {
    setIsLoading(true);
    const requestObj = {
      baseUrl: 'zoomApiUrl',
      apiEndPoint: 'downloadTanNumberTemplate',
      method: 'GET',
      responseType: 'arraybuffer',
      successCb: res => {
        const blob = new Blob([res], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'upload_tan_detail_template.xlsx';
        link.click();
        setIsLoading(false);
      },
      failureCb: res => {
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Unable to download sample template.'
        );
        setIsLoading(false);
      },
      catchCb: res => {
        toastr.error(
          'Something went wrong!',
          'Unable to download sample template.'
        );
        setIsLoading(false);
      }
    };

    return makeApiCall(requestObj);
  };

  return {
    isLoading,
    downloadTanNumberTemplate
  };
};
